import React from 'react'
import { AllApi } from '../Api/AllApi'
import { GameDB } from './../DataBase/GameDB'
import {
    SetAppSettingData,
    SetUserLeagueData,
    SetMyLeagueRank,
    SetLeagueLimitJoinProgress,
    SetLeagueMinimumJoinProgress,
    SetRewardLeague,
    SetMyLeagueRankNumber,
    SetGiftTopjoin,
    SetNameAccount,
    SetJoinCountRedux,
    SetPromotionBottomSheet,
    SetUserReward,
    SetClaimRewardCall,
    SetDataClaimReward,
    SetXpLimit,
    SetXpCount,
    SetLevelUserHeaderProgress,
    SetSnackBarEndLeagueState, SetTopJoinerTime, SetIsBetweenLeaguge,SetverifyBotEnable
} from './../app/Game'
export class OnlineRequestAppSettingGame extends React.Component {
    constructor() {
        super();
    }
    async GetAppSetting () {
        let Data;
        const MakeApiClass = new AllApi();
        let Result = await MakeApiClass.appSetting()
        // console.log(Result.data.appSetting.verifyBotEnable)
         
        if (Result.code == 200) {
            Data = Result
        } else if (Result.code == 999) {
            Data = 'Network'
        }
        return Data
    }
   async OnlineRequestAppSetting(dispatch) {

    let AppSettingRes = await this.GetAppSetting(); 
   
 
    if (AppSettingRes != 'Network') {
        dispatch(SetAppSettingData(AppSettingRes.data))
        let cacheTime = AppSettingRes.data.cacheTime
        dispatch(SetverifyBotEnable(AppSettingRes.data.appSetting.verifyBotEnable))

        let NowInNow = new Date().getTime();
        let LastTime = cacheTime * 1000 + NowInNow;
        GameDB.AppSetting.toArray(function (AppSettingItem) {
            if (AppSettingItem.length > 0) {
                GameDB.AppSetting.toCollection().modify(App => {
                    App.LastTime = LastTime;
                    // App.LastUpdate = NowInNow
                    App.AppSetting = AppSettingRes.data.appSetting
                });
            } else {
                GameDB.AppSetting.add({ AppSetting: AppSettingRes.data.appSetting, LastTime, LastUpdate: NowInNow });
            }

        });
    } else {
        // handleClick({ vertical: 'bottom', horizontal: 'center' })
        // OfflineRequestAppSetting()
      
    return AppSettingRes

    }
    return AppSettingRes
    }

   

}
